import "core-js/modules/es.array.concat";
import _objectSpread from "/Users/guoshengli/Documents/vue/kexin-qiye/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import request from '@/utils/request';
import { API } from '@/settings.js'; // 登录

export function login(data) {
  return request({
    // url: API.PREFIX1 + 'oauth/token',
    url: API.PREFIX1 + "auth/merchant/v3/account_login?challenge=".concat(encodeURI(data.challenge), "&seccode=").concat(encodeURI(data.seccode), "&validate=").concat(encodeURI(data.validate)),
    method: 'post',
    data: data
  });
} // 退出登录

export function logout() {
  return request({
    url: API.PREFIX1 + 'ucc/verification/v1/logout',
    method: 'post'
  });
} // 忘记密码

export function forgetPwd(params) {
  return request({
    url: API.PREFIX2 + 'merchant/account/forgetPwd',
    method: 'get',
    params: params
  });
} // 修改密码

export function modify_password(data) {
  return request({
    url: API.PREFIX2 + 'merchant/account/setPwd',
    method: 'put',
    data: data
  });
} // 获取组织

export function get_organization_list(data) {
  return request({
    url: API.PREFIX1 + 'auth/merchant/v2/get_user_organization_permission',
    method: 'get'
  });
} // 获取用户权限

export function getInfo(params) {
  return request({
    url: API.PREFIX1 + 'auth/merchant/v1/get_auth',
    method: 'get',
    params: params
  });
} // 获取登录用户权限

export function get_employee_auth() {
  return request({
    url: API.PREFIX1 + 'auth/merchant/v2/get_employee_auth',
    method: 'get'
  });
} // 验证码登录

export function codeLogin(data) {
  return request({
    url: API.PREFIX1 + 'auth/merchant/v3/phone_login',
    method: 'post',
    data: data
  });
} // 获取验证码

export function getSMS(data) {
  return request({
    url: API.PREFIX1 + 'ucc/verification/v1/send_verification_sms',
    method: 'post',
    data: _objectSpread(_objectSpread({}, data), {}, {
      signId: 0
    })
  });
} // 获取验证码（带极验参数）

export function getPolarSMS(data) {
  return request({
    url: API.PREFIX1 + "ucc/verification/v1/geetest/send_verification_sms?challenge=".concat(encodeURI(data.challenge), "&seccode=").concat(encodeURI(data.seccode), "&validate=").concat(encodeURI(data.validate)),
    method: 'post',
    data: _objectSpread(_objectSpread({}, data), {}, {
      signId: 0
    })
  });
} // 校验验证码

export function check_verification_sms(data) {
  return request({
    url: API.PREFIX1 + 'ucc/verification/v1/check_verification_sms',
    method: 'post',
    data: data
  });
} // 获取极验签名

export function getRegisterCodeSafe() {
  return request({
    url: '/registerCodeSafe',
    method: 'get'
  });
} // 重置密码 获取验证码

export function getResetSms(data) {
  return request({
    url: API.PREFIX1 + 'ucc/verification/v1/send_sms',
    method: 'post',
    data: data
  });
} // 商家忘记密码重设密码

export function resetPwd(data) {
  return request({
    url: API.PREFIX1 + 'ucc/verification/merchant/password/v1/reset',
    method: 'post',
    data: data
  });
}